import { render, staticRenderFns } from "./analysisDetails.vue?vue&type=template&id=5470276a&scoped=true&"
import script from "./analysisDetails.vue?vue&type=script&lang=js&"
export * from "./analysisDetails.vue?vue&type=script&lang=js&"
import style0 from "./analysisDetails.vue?vue&type=style&index=0&id=5470276a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5470276a",
  null
  
)

export default component.exports